import React from "react";
import Button from "./Button";
import atyant from "../imgAndpdf/atyant.jpg";
import './Home.css'

function Home() {
  return (
    <div className="home-conatiner" id="home">
      <div className="home-parent">
        <div className="home-details">
          <h4>Hello I'M</h4>
          <h2>Atyant Kumar</h2>
          <span>Frontend Developer</span>
        </div>
        <Button />
        <div className="home-img">
          <img src={atyant}></img>
        </div>
      </div>
      <div>
       
      </div>
    </div>
  );
}

export default Home;
